module.exports = __webpack_public_path__ + "static/media/image-14.72870d67.png";